<template>
    <CButton
        :block="block"
        :color="color"
        :variant="variant"
        :square="square"
        :size="size"
        :disabled="disabled"
        :type="type"
        :title="title"
        @click="$emit('click')"
    >
        <CIcon :content="$options.icons.cilTrash"/>
    </CButton>
</template>

<script>
import { cilTrash } from '@coreui/icons';
export default {
    name: "ButtonTrash",
    icons:{
        cilTrash
    },
    props: {
        block: {
            type: Boolean,
            default: false
        },
        color: {
            default: 'danger',
            type: String
        },
        variant:{
            default: 'outline',
            type: String
        },
        square:{
            default: true,
            type: Boolean
        },
        size: {
            default: "sm",
            type: String
        },
        disabled: Boolean,
        type: String,
        title: String
    }

}
</script>
<style lang="scss">

</style>